import { IEquisModalDialogConfig } from '@tn-equis/core/components/modal-dialog';

export function createDownloadAppDialog(
  title: string,
): IEquisModalDialogConfig {
  return {
    type: 'custom',
    size: 'small',
    data: {
      header: {
        title,
        crossButton: true,
        alignContent: 'center',
      },
    },
  };
}

const SUCCESS_DIALOG: IEquisModalDialogConfig = {
  data: {
    header: {
      title: '',
      crossButton: true,
    },
    body: {
      sticker: {
        path: './assets/stickers/success/success.json',
        height: 150,
        width: 150,
        loop: false,
      },
      title: '¡Listo! Vas a recibir el link por WhatsApp',
      message:
        'Te enviamos el link a tu número. Puede demorar algunos minutos en llegar.',
    },
  },
  size: 'extra-small',
  type: 'alert',
};

const RETRY_DIALOG: IEquisModalDialogConfig = {
  data: {
    header: {
      title: '',
      crossButton: true,
    },
    footer: {
      buttonList: [
        {
          text: 'Cancelar',
          disabled: false,
          closeModal: true,
        },
        {
          text: 'Intentar de nuevo',

          disabled: false,
          closeModal: true,
        },
      ],
    },
    body: {
      sticker: {
        path: './assets/stickers/hamster/hamster.json',
        height: 150,
        width: 150,
        loop: true,
      },
      title: 'Algo pasó y no podemos continuar',
      message:
        'Estamos trabajando para solucionarlo. ¿Nos das otra oportunidad?',
    },
  },
  size: 'extra-small',
  type: 'alert',
};

const ERROR_DIALOG: IEquisModalDialogConfig = {
  data: {
    header: {
      title: '',
      crossButton: true,
    },
    footer: {
      buttonList: [
        {
          text: 'Entendido',
          disabled: false,
          closeModal: true,
        },
      ],
    },
    body: {
      sticker: {
        path: './assets/stickers/hamster/hamster.json',
        height: 150,
        width: 150,
        loop: true,
      },
      title: 'No podemos continuar',
      message: 'Estamos trabajando para solucionarlo. Probá más tarde.',
    },
  },
  size: 'extra-small',
  type: 'alert',
};

export const ButtonDownloadDialogs = {
  createDownloadAppDialog,
  SUCCESS_DIALOG,
  RETRY_DIALOG,
  ERROR_DIALOG,
};
